module.exports = __webpack_public_path__ + "img/xmark-black.0e39eec2.svg";